import React, { useContext } from "react";
import { DropdownMenuContent as DropdownPrimitiveMenuContent, Portal as DropdownPrimitivePortal } from "@radix-ui/react-dropdown-menu";
import PropTypes from "prop-types";
import cc from "classcat";
import { twMerge } from "tailwind-merge";
import { DropdownContext } from "./Dropdown";
DropdownContent.propTypes = {
    children: PropTypes.node.isRequired,
    side: PropTypes.oneOf([
        "top",
        "left",
        "bottom",
        "right"
    ]),
    sideOffset: PropTypes.number,
    align: PropTypes.oneOf([
        "start",
        "center",
        "end"
    ]),
    alignOffset: PropTypes.number,
    className: PropTypes.string,
    enhanceRoundedMd: PropTypes.bool
};
export default function DropdownContent(param) {
    var children = param.children, side = param.side, sideOffset = param.sideOffset, align = param.align, alignOffset = param.alignOffset, className = param.className, _param_enhanceRoundedMd = param.//? used to apply rounded-t-md to first validElement child, and rounded-b-md to last validElement child
    enhanceRoundedMd, enhanceRoundedMd = _param_enhanceRoundedMd === void 0 ? false : _param_enhanceRoundedMd;
    var fadeIn = useContext(DropdownContext).fadeIn;
    var enhancedChildren;
    //! Add conditional classes based on position
    //? Also checking if validElement (conditionally rendered elements might be null,and we should not attempt to enhance null :D
    if (enhanceRoundedMd) {
        var validChildren = React.Children.toArray(children).filter(React.isValidElement);
        enhancedChildren = validChildren.map(function(child, index) {
            var isFirst = index === 0;
            var isLast = index === validChildren.length - 1;
            var enhancedChild = /*#__PURE__*/ React.cloneElement(child, {
                className: twMerge(cc([
                    child.props.className,
                    {
                        "rounded-t-md": isFirst
                    },
                    {
                        "rounded-b-md": isLast
                    }
                ]))
            });
            return enhancedChild;
        });
    }
    return /*#__PURE__*/ React.createElement(DropdownPrimitivePortal, null, /*#__PURE__*/ React.createElement(DropdownPrimitiveMenuContent, {
        loop: true,
        side: side,
        sideOffset: sideOffset,
        align: align,
        alignOffset: alignOffset,
        onCloseAutoFocus: function(e) {
            return e.preventDefault();
        },
        className: twMerge(cc([
            "z-50",
            "shadow-md",
            "text-black",
            "outline",
            "rounded-lg",
            "bg-white",
            "border",
            "p-3",
            "dark:bg-blue-800",
            "dark:border-blue-750",
            "transition-all",
            "overflow-y-auto",
            "duration-300",
            {
                "scale-1 origin-[var(--radix-dropdown-menu-content-transform-origin)] opacity-100": fadeIn
            },
            {
                "scale-0 opacity-0": !fadeIn
            },
            className
        ]))
    }, /*#__PURE__*/ React.createElement("ul", null, enhancedChildren ? enhancedChildren : children)));
}
